<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.ds_report') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.ds_report') }}</li>
              </ul>
            </div>
          </div>
          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                  <div class="card-header">
                    <h4 class="card-title mb-0">{{ $t('ds_report_info') }}</h4>
                  </div>
                  <div class="card-body">
                      <div class="form-group row">
                        <label class="col-md-4 col-form-label">{{ $t('time_period') }}<span class="text-danger">*</span></label>
                        <div class="col-md-4">
                          <label class="col-form-label" v-show="!statusReport">{{ $t('start_date') }}<span class="text-danger">*</span></label>
                          <label class="col-form-label" v-show="statusReport">{{ $t('report_date') }}<span class="text-danger">*</span></label>
                          <date-picker v-model="startDate" :config="datetimeOptions"></date-picker>
                        </div>
                        <div class="col-md-4" v-show="!statusReport">
                          <label class="col-form-label">{{ $t('end_date') }}<span class="text-danger">*</span></label>
                          <date-picker v-model="endDate" :config="datetimeOptions"></date-picker>
                        </div>
                        <span class="error-message text-danger" v-show="v$.startDate.$errors.length>0 || v$.endDate.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">{{ $t('authors') }}<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="select form-control partner-select" v-model="author" v-select2 data-container-css-class="form-control">
                            <option value="sven">Sven Lenz</option>
                            <option value="alissa">Alissa Lenz</option>
                            <option value="nicole">Nicole Frister</option>
                            <option value="werner">Werner Wittmann</option>
                            <option value="kaiyi">Kaiyi Lin</option>
                            <option value="others">Sonstiges</option>
                          </select>
                          <div class="pt-2" v-show="author==='others'">
                            <textarea v-model="otherAuthor" style="width: 100%"></textarea>
                          </div>
                        </div>
                        <span class="error-message text-danger" v-show="v$.author.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">{{ $t('template') }}<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="form-control template-select" v-model="selectedReportTemplate" v-select2>
                            <option :value="template.name" v-for="template in reportTemplate">{{ template.name }}</option>
                          </select>
                        </div>
                        <span class="error-message text-danger" v-show="v$.selectedReportTemplate.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">{{ $t('addressed_to') }}<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="form-control reader-select" v-model="selectedReader" v-select2>
                            <option :value="reader.value" v-for="reader in readerSelect">{{ reader.name }}</option>
                          </select>
                        </div>
                        <span class="error-message text-danger" v-show="v$.selectedReader.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">{{ $t('reporting_year') }}<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <input type="text" class="form-control" v-model="reportYear"/>
                        </div>
                        <span class="error-message text-danger" v-show="v$.reportYear.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="text-right">
                        <!--<router-link :to="{name: 'avv-content', params: {surveyJson: surveyJson, partnerName: partnerName, partnerAddress: partnerAddress, contractName: contractName, gapInput: gapInput, filename: filename, auftragsgeber: auftragsgeber, remarks: remarks}}" @click.native="uploadFile">-->
                          <button class="btn btn-primary" @click="generateReport">{{ $t('generate') }}</button>
                        <!--</router-link>-->
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="processReport || showReport">
              <div class="col-xl-6 d-flex">
                <div class="card" v-show="showReport">
                  <div class="card-header clearfix text-left" style="margin: 20px auto">
                    <h4>{{ $t('ds_report') }}</h4>
                  </div>
                  <div class="card-body text-left">
                    <p><strong>{{ $t('report') }}:</strong><a :href="hostURL + reportURL" target="_blank" class="FileLink pl-5">{{ accountName }}_DS_Bericht.docx</a> </p>
                  </div>
                </div>
                <FingerPrintSpinner  v-show="processReport && !showReport" color="#9b3136" :size="300" :container-padding="100" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service, hostURL } from '@/utils/request'
import {mapState} from 'vuex'
import {initSelect2} from '@/utils/index.js';
import datePicker from 'vue-bootstrap-datetimepicker';
import {required, requiredIf} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
export default {
  name: 'GenerateDSReport',
  components: {FingerPrintSpinner, datePicker},
  data: function() {
    return {
      datetimeOptions: {
        format: 'DD.MM.YYYY',
        useCurrent: true,
      },
      startDate: '',
      endDate: '',
      reportYear: '',
      author: [],
      otherAuthor: '',
      showReport: false,
      processReport: false,
      statusReport: false,
      reportURL: '',
      hostURL: hostURL,
      reportTemplate: [],
      selectedReportTemplate: '',
      selectedReader: '',
    }
  },
  validations() {
    return {
      startDate: {required, $lazy: true},
      endDate: {required: requiredIf(!this.statusReport), $lazy: true},
      selectedReportTemplate: {required, $lazy: true},
      reportYear: {required, $lazy: true},
      author: {required, $lazy: true},
      selectedReader: {required, $lazy: true},
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  computed: {...mapState({
      accountid: state => state.account.accountid,
      accountName: state => state.account.name,
      username: state => state.user.username,
      dsb: state => state.account.dsb,
      betreuer: state => state.account.betreuer,
  }),

    readerSelect() {
      return [
        {value: 'der Geschäftsführung', name: this.$t('management')},
        {value: 'dem Vorstand', name: this.$t('executive_board')},
      ]
    },
  },
  watch:{},
  mounted() {
    this.getReportTemplate();
    initSelect2();
    this.$nextTick(() => {
      const that = this
      $('.template-select').on('change', function (e) {
        const selectedVal = $(this).val()
        const selectedTemplate = that.reportTemplate.find(template => template.name === selectedVal)
        if (selectedTemplate && selectedTemplate.status_report) {
          that.statusReport = true
        } else {
          that.statusReport = false
        }
      })
    })
  },
  methods: {
    getReportTemplate: async function() {
      service.request({
        url: 'todos/v1/report_templates/',
        method: 'GET',
        responseType: 'json'
      }).then((res) => {
          this.reportTemplate = res.data
        }
      ).catch((err) => {
        this.$vToastify.error(err.toString())
      })
    },
    generateReport: async function() {
      const isValid = await this.v$.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.processReport = true
      this.reportURL = ''
      this.showReport = false
      service.request({
        url: 'todos/v1/generate_ds_report/',
        method: 'POST',
        responseType: 'json',
        data: {
          customerID: this.accountid,
          username: this.username,
          startDate: this.startDate,
          endDate: this.endDate,
          reportYear: this.reportYear,
          author: this.author,
          template: this.selectedReportTemplate,
          reader: this.selectedReader,
          dsb: this.dsb,
          betreuer: this.betreuer,
        }
      }).then((res) => {
          this.reportURL = res.data
          this.processReport = false
          this.showReport = true
        }
      ).catch((err) => {
        this.reportURL = 'Fehler aufgetreten! Bitte versuchen Sie es erneut.'
        this.processReport = false
        this.showReport = true
      })
    },
  }
}
</script>

<style scoped>

</style>
